/**
 * Reconciliation Translations
 */

import { Translations } from '../shared/i18n';

export const reconciliationTranslations: Translations = {
    tr: {
        reconciliationTitle: 'Eşleştirme',
        reconciliationDescription: 'Banka ekstrelerinizi gider ve gelirinizle eşleştirin',
        navReconciliation: 'Eşleştirme',
        // Upload panels
        uploadExpenses: 'Gider Yükle',
        uploadStatements: 'Banka Ekstresi Yükle',
        uploadRevenue: 'Gelir Yükle',
        recentDocs: 'Son Belgeler',
        noDocs: 'Henüz belge yok',
        dropOrClick: 'Sürükle veya tıkla',
        docsProcessing: 'dosya işleniyor...',
        docsFailed: 'dosya başarısız',
        statusPending: 'Bekliyor',
        statusProcessing: 'İşleniyor',
        statusFailed: 'Başarısız',
        statusCancelled: 'İptal Edildi',
        cancelProcessing: 'İptal',
        // Matching
        matchingTitle: 'Eşleştirme Sonuçları',
        bankTransaction: 'Banka İşlemi',
        expenseMatch: 'Gider Eşleşme',
        revenueMatch: 'Gelir Eşleşme',
        matched: 'Eşleşti',
        unmatched: 'Eşleşmedi',
        partialMatch: 'Kısmi Eşleşme',
        noMatch: 'Eşleşme yok',
        // Summary
        matchSummary: 'Eşleştirme Özeti',
        totalTransactions: 'Toplam İşlem',
        matchedCount: 'Eşleşen',
        unmatchedCount: 'Eşleşmeyen',
        //Headers
        groupHeaderBank: 'Banka Ekstresi',
        groupHeaderDocs: 'Giderler & Gelirler',
        swapPrimaryView: 'Tabloları yer değiştir',
        // Columns
        colDate: 'Tarih',
        colDescription: 'Açıklama',
        colAmount: 'Tutar',
        colFilename: 'Dosya Adı',
        colMatch: 'Eşleşme',
        colConfidence: 'Güven',
        colType: 'Tür',
        debit: 'Giden',
        credit: 'Gelen',
        colDocument: 'Belge',
        // Confidence
        highConfidenceCount: 'Yüksek Güven',
        confidenceHigh: 'Yüksek',
        confidenceMedium: 'Orta',
        confidenceLow: 'Düşük',
        // Matching actions
        matchButton: 'Tümünü Eşleştir',
        rematchButton: 'Tümünü Eşleştir',
        autoMatchStepLabel: 'Tek tıkla tümünü eşleştir',
        autoMatchTooltip: 'Tüm banka işlemleri fatura ve makbuzlarla otomatik eşleştirilir. Elle bağlanan belgeler korunur.',
        matchingInProgress: 'Eşleştiriliyor...',
        matchingComplete: 'Eşleştirme tamamlandı',
        lastMatchInfo: '{count} yeni eşleşme bulundu',
        reconNotifExpenses: 'gider',
        reconNotifRevenues: 'gelir',
        reconNotifStatements: 'banka ekstresi',
        reconNotifUnprocessed: 'henüz otomatik eşleştirmeye girmedi',
        reconNotifAllProcessed: 'Tüm belgeler eşleştirme sürecinden geçti',
        matchingFailed: 'Eşleştirme başarısız',
        noMatchesYet: 'Henüz eşleştirme yapılmadı',
        noMatchesHint: 'Belge ve ekstre yükledikten sonra "Eşleştir" butonuna tıklayın',
        deleteMatchConfirm: 'Bu eşleştirmeyi silmek istediğinize emin misiniz?',
        // Empty state
        noTransactionsToMatch: 'Eşleştirme yapılacak işlem bulunamadı',
        noTransactionsHint: 'Banka ekstresi yükleyerek başlayın',
        // Filters
        filterAll: 'Tümü',
        filterMatched: 'Eşleşen',
        filterUnmatched: 'Eşleşmeyen',
        filterNew: 'Yeni',
        filterNewTooltip: 'Sadece son eşleştirme çalışmasında oluşan eşleşmeleri göster',
        // Actions
        linkButton: 'Bağla',
        unlinkButton: 'Kaldır',
        confirmMatch: 'Onayla',
        unlinkConfirm: 'Bu eşleştirmeyi kaldırmak istediğinize emin misiniz?',
        // Modal
        linkTransaction: 'Belge Bağla',
        searchDocuments: 'Dosya adı veya tedarikçi ara...',
        selectDocument: 'Seç',
        noDocumentsAvailable: 'Uygun belge bulunamadı',
        // Status
        statusAuto: 'Otomatik',
        statusManual: 'Manuel',
        statusConfirmed: 'Onaylı',
        // Pagination
        prevPage: 'Önceki',
        nextPage: 'Sonraki',
        // Match Detail Modal
        matchDetailTitle: 'Eşleşme Detayı',
        transactionInfo: 'İşlem Bilgileri',
        linkedDocument: 'Bağlı Belge',
        bankName: 'Banka',
        invoiceNumber: 'Fatura No',
        vendorName: 'Tedarikçi',
        previewDocument: 'Belge önizlemesi için bir belge seçin',
        availableDocsTitle: 'Giderler & Gelirler',
        closeButton: 'Kapat',
        // Multi-link
        linkedDocuments: 'Bağlı Belgeler',
        bankStatementPreview: 'Banka Ekstresi',
        highlightTransaction: 'İşlemi Vurgula',
        fileNotFound: 'Dosya bulunamadı',
        documentAlreadyLinked: 'Bu belge zaten bağlı',
        linkMore: 'Belge Ekle',
        // Document Picker
        confirmLinkTitle: 'Bu belgeyi bağlamak istiyor musunuz?',
        confirmLinkYes: 'Evet, Bağla',
        confirmLinkCancel: 'Vazgeç',
        docAdded: 'Eklendi',
        proximityScore: 'Uyum',
        pickerExpenses: 'Giderler',
        pickerRevenue: 'Gelirler',
        showAllDocs: 'Tüm Belgeleri Göster',
        dateRange: 'Tarih Aralığı',
        days: 'gün',
        pickerDate: 'Tarih',
        pickerAmount: 'Tutar',
        pickerCurrency: 'Para Birimi',
        pickerSupplier: 'Tedarikçi',
        more: 'Daha Fazla',
        loadingDocs: 'Yükleniyor...',
        // Re-match options
        rematchOptionTitle: 'Yeniden Eşleştir',
        rematchOptionMessage: 'Mevcut bağlantılara ne yapılsın?',
        rematchPreserve: 'Yalnızca yeni eklenen dosyaları bağla (Önerilen)',
        rematchPreserveHint: 'Yalnızca yeni eklenen belgeler bağlanır',
        rematchKeepManual: 'Manuel bağlantıları koru',
        rematchKeepManualHint: 'Otomatik eşleşmeler silinir, elle bağlananlar korunur',
        rematchSelectiveBtn: 'Seçerek bağla',
        rematchSelectiveHint: 'Hangi bağlantıların korunacağını seçin',
        // Selective re-match modal
        rematchModalTitle: 'Seçerek Tekrar Eşleştir',
        rematchModalDesc: 'Korumak istediğiniz eşleşmeleri seçin. Seçilmeyenler silinip yeniden eşleştirilir.',
        rematchSelectAll: 'Tümünü Seç',
        rematchDeselectAll: 'Tümünü Kaldır',
        rematchRunButton: 'Tekrar Eşleştir',
        rematchRunCount: 'eşleşme korunacak',
        rematchNoMatches: 'Henüz eşleşme yok',
        searchTransactions: 'İşlem, açıklama veya belge ara...',
        showMore: 'Daha fazla göster',
        showLess: 'Daha az göster',
        exportExcel: 'Dışa Aktar',
        showPerPage: 'Göster',
        // Month filter
        monthAll: 'Tümü',
        monthJan: 'Oca', monthFeb: 'Şub', monthMar: 'Mar', monthApr: 'Nis',
        monthMay: 'May', monthJun: 'Haz', monthJul: 'Tem', monthAug: 'Ağu',
        monthSep: 'Eyl', monthOct: 'Eki', monthNov: 'Kas', monthDec: 'Ara',
        // Stale warnings
        staleWarning: 'Belge düzenlendi. eşleşme güncel olmayabilir',
        staleFieldsEdited: 'Düzenlenen alanlar:',
        staleDismiss: 'Tamam',
        staleDismissConfirm: 'Bu uyarıyı kaldırmak istediğinize emin misiniz? Eşleşme güncel olarak işaretlenecek.',
        aiReviewButton: 'AI Analizi',
        aiLoading: 'Analiz ediliyor...',
        aiRetry: 'Tekrar analiz et',
        // Month picker
        monthsSelected: 'ay seçili',
        dateFrom: 'Başlangıç',
        dateTo: 'Bitiş',
        filterApply: 'Uygula',
        // Duplicate exclusion
        duplicateExcludedCount: '{count} mükerrer işlem hariç tutuldu',
        duplicateExcludedTooltip: 'Kopya olarak etiketlenen veya manuel hariç tutulan işlemler eşleştirmeye dahil edilmez',
        // Export
        exportDate: 'Tarih',
        exportDescription: 'Aciklama',
        exportAmount: 'Tutar',
        exportType: 'Tur',
        exportMatchedDoc: 'Eslesen Belge',
        exportVendor: 'Tedarikci',
        exportDocAmount: 'Belge Tutari',
        exportDocDate: 'Belge Tarihi',
        exportConfidence: 'Guven',
        exportStatus: 'Durum',
        exportMatched: 'Eslesmis',
        exportUnmatched: 'Eslesmemis',
        exportPeriod: 'Donem',
        exportTxCount: 'Islem Sayisi',
        exportMatchedCount: 'Eslesmis',
        exportUnmatchedCount: 'Eslesmemis',
        exportTotalAmount: 'Toplam Tutar',
        exportSummarySheet: 'Ozet',
        exportNoData: 'Secilen tarih araliginda islem bulunamadi.',
        exportFilenamePrefix: 'Mutabakat_',
        exportMonthJan: 'Ocak', exportMonthFeb: 'Subat', exportMonthMar: 'Mart',
        exportMonthApr: 'Nisan', exportMonthMay: 'Mayis', exportMonthJun: 'Haziran',
        exportMonthJul: 'Temmuz', exportMonthAug: 'Agustos', exportMonthSep: 'Eylul',
        exportMonthOct: 'Ekim', exportMonthNov: 'Kasim', exportMonthDec: 'Aralik',
    },
    en: {
        reconciliationTitle: 'Reconciliation',
        reconciliationDescription: 'Match your bank statements with your expense & revenue',
        navReconciliation: 'Reconciliation',
        // Upload panels
        uploadExpenses: 'Upload Expenses',
        uploadStatements: 'Upload Bank Statements',
        uploadRevenue: 'Upload Revenues',
        recentDocs: 'Recent Documents',
        noDocs: 'No documents yet',
        dropOrClick: 'Drop or click',
        docsProcessing: 'document(s) processing...',
        docsFailed: 'document(s) failed',
        statusPending: 'Pending',
        statusProcessing: 'Processing',
        statusFailed: 'Failed',
        statusCancelled: 'Cancelled',
        cancelProcessing: 'Cancel',
        // Matching
        matchingTitle: 'Matching Results',
        bankTransaction: 'Bank Transaction',
        expenseMatch: 'Expense Match',
        revenueMatch: 'Revenue Match',
        matched: 'Matched',
        unmatched: 'Unmatched',
        partialMatch: 'Partial Match',
        noMatch: 'No match',
        // Summary
        matchSummary: 'Match Summary',
        totalTransactions: 'Total Transactions',
        matchedCount: 'Matched',
        unmatchedCount: 'Unmatched',
        //Headers
        groupHeaderBank: 'Bank Statement',
        groupHeaderDocs: 'Expenses & Revenues',
        swapPrimaryView: 'Swap tables',
        // Columns
        colDate: 'Date',
        colDescription: 'Description',
        colAmount: 'Amount',
        colFilename: 'Filename',
        colMatch: 'Match',
        colConfidence: 'Confidence',
        colType: 'Type',
        debit: 'Outgoing',
        credit: 'Incoming',
        colDocument: 'Document',
        // Confidence
        highConfidenceCount: 'High Confidence',
        confidenceHigh: 'High',
        confidenceMedium: 'Medium',
        confidenceLow: 'Low',
        // Matching actions
        matchButton: 'Auto-match all',
        rematchButton: 'Auto-match all',
        autoMatchStepLabel: 'One click to match everything',
        autoMatchTooltip: 'Automatically match all bank transactions to your invoices and receipts. Manually linked documents are always preserved.',
        matchingInProgress: 'Matching...',
        matchingComplete: 'Matching complete',
        lastMatchInfo: '{count} new matches found',
        reconNotifExpenses: 'expenses',
        reconNotifRevenues: 'revenues',
        reconNotifStatements: 'bank statements',
        reconNotifUnprocessed: "haven't been auto-matched yet",
        reconNotifAllProcessed: 'All documents have been processed',
        matchingFailed: 'Matching failed',
        noMatchesYet: 'No matches yet',
        noMatchesHint: 'Upload documents and statements, then click "Match"',
        deleteMatchConfirm: 'Are you sure you want to delete this match?',
        // Empty state
        noTransactionsToMatch: 'No transactions to match',
        noTransactionsHint: 'Start by uploading a bank statement',
        // Filters
        filterAll: 'All',
        filterMatched: 'Matched',
        filterUnmatched: 'Unmatched',
        filterNew: 'New',
        filterNewTooltip: 'Show only matches created in the last matching run',
        // Actions
        linkButton: 'Link',
        unlinkButton: 'Unlink',
        confirmMatch: 'Confirm',
        unlinkConfirm: 'Are you sure you want to unlink this match?',
        // Modal
        linkTransaction: 'Link Document',
        searchDocuments: 'Search filename or vendor...',
        selectDocument: 'Select',
        noDocumentsAvailable: 'No documents available',
        // Status
        statusAuto: 'Auto',
        statusManual: 'Manual',
        statusConfirmed: 'Confirmed',
        // Pagination
        prevPage: 'Prev',
        nextPage: 'Next',
        // Match Detail Modal
        matchDetailTitle: 'Match Detail',
        transactionInfo: 'Transaction Info',
        linkedDocument: 'Linked Document',
        bankName: 'Bank',
        invoiceNumber: 'Invoice No',
        vendorName: 'Vendor',
        previewDocument: 'Select a document to preview',
        availableDocsTitle: 'Expenses & Revenues',
        closeButton: 'Close',
        // Multi-link
        linkedDocuments: 'Linked Documents',
        bankStatementPreview: 'Bank Statement',
        highlightTransaction: 'Highlight Transaction',
        fileNotFound: 'File not available',
        documentAlreadyLinked: 'Document already linked',
        linkMore: 'Link More',
        // Document Picker
        confirmLinkTitle: 'Link this document?',
        confirmLinkYes: 'Yes, Link',
        confirmLinkCancel: 'Cancel',
        docAdded: 'Added',
        proximityScore: 'Score',
        pickerExpenses: 'Expenses',
        pickerRevenue: 'Revenues',
        showAllDocs: 'Show All Documents',
        dateRange: 'Date Range',
        days: 'days',
        pickerDate: 'Date',
        pickerAmount: 'Amount',
        pickerCurrency: 'Currency',
        pickerSupplier: 'Supplier',
        more: 'More',
        loadingDocs: 'Loading...',
        // Re-match options
        rematchOptionTitle: 'Re-match',
        rematchOptionMessage: 'What should happen with the existing links?',
        rematchPreserve: 'Link newly added files only (Recommended)',
        rematchPreserveHint: 'Only newly added documents will be linked',
        rematchKeepManual: 'Keep manual links',
        rematchKeepManualHint: 'Auto matches are removed, manual links are preserved',
        rematchSelectiveBtn: 'Selective links',
        rematchSelectiveHint: 'Choose which links to keep',
        // Selective re-match modal
        rematchModalTitle: 'Selective Re-match',
        rematchModalDesc: 'Select matches to keep. Unselected ones will be deleted and re-matched.',
        rematchSelectAll: 'Select All',
        rematchDeselectAll: 'Deselect All',
        rematchRunButton: 'Re-match',
        rematchRunCount: 'match(es) will be kept',
        rematchNoMatches: 'No matches yet',
        searchTransactions: 'Search transactions, description or document...',
        showMore: 'Show more',
        showLess: 'Show less',
        exportExcel: 'Export',
        showPerPage: 'Show',
        // Month filter
        monthAll: 'All',
        monthJan: 'Jan', monthFeb: 'Feb', monthMar: 'Mar', monthApr: 'Apr',
        monthMay: 'May', monthJun: 'Jun', monthJul: 'Jul', monthAug: 'Aug',
        monthSep: 'Sep', monthOct: 'Oct', monthNov: 'Nov', monthDec: 'Dec',
        // Stale warnings
        staleWarning: 'Document was edited. match may be outdated',
        staleFieldsEdited: 'Edited fields:',
        staleDismiss: 'Dismiss',
        staleDismissConfirm: 'Are you sure you want to dismiss this warning? The match will be marked as up-to-date.',
        aiReviewButton: 'AI Analysis',
        aiLoading: 'Analyzing...',
        aiRetry: 'Re-analyze',
        // Month picker
        monthsSelected: 'months selected',
        dateFrom: 'From',
        dateTo: 'To',
        filterApply: 'Apply',
        // Duplicate exclusion
        duplicateExcludedCount: '{count} duplicate transactions excluded',
        duplicateExcludedTooltip: 'Transactions tagged as duplicate or manually excluded are not included in matching',
        // Export
        exportDate: 'Date',
        exportDescription: 'Description',
        exportAmount: 'Amount',
        exportType: 'Type',
        exportMatchedDoc: 'Matched Document',
        exportVendor: 'Vendor',
        exportDocAmount: 'Document Amount',
        exportDocDate: 'Document Date',
        exportConfidence: 'Confidence',
        exportStatus: 'Status',
        exportMatched: 'Matched',
        exportUnmatched: 'Unmatched',
        exportPeriod: 'Period',
        exportTxCount: 'Transaction Count',
        exportMatchedCount: 'Matched',
        exportUnmatchedCount: 'Unmatched',
        exportTotalAmount: 'Total Amount',
        exportSummarySheet: 'Summary',
        exportNoData: 'No transactions found in the selected date range.',
        exportFilenamePrefix: 'Reconciliation_',
        exportMonthJan: 'January', exportMonthFeb: 'February', exportMonthMar: 'March',
        exportMonthApr: 'April', exportMonthMay: 'May', exportMonthJun: 'June',
        exportMonthJul: 'July', exportMonthAug: 'August', exportMonthSep: 'September',
        exportMonthOct: 'October', exportMonthNov: 'November', exportMonthDec: 'December',
    },
    de: {
        reconciliationTitle: 'Abgleich',
        reconciliationDescription: 'Gleichen Sie Ihre Kontoauszüge mit Ihren Ausgaben & Einnahmen ab',
        navReconciliation: 'Abgleich',
        // Upload panels
        uploadExpenses: 'Ausgaben hochladen',
        uploadStatements: 'Kontoauszüge hochladen',
        uploadRevenue: 'Einnahmen hochladen',
        recentDocs: 'Letzte Dokumente',
        noDocs: 'Noch keine Dokumente',
        dropOrClick: 'Ablegen oder klicken',
        docsProcessing: 'Dokument(e) werden verarbeitet...',
        docsFailed: 'Dokument(e) fehlgeschlagen',
        statusPending: 'Wartend',
        statusProcessing: 'Verarbeitung',
        statusFailed: 'Fehlgeschlagen',
        statusCancelled: 'Abgebrochen',
        cancelProcessing: 'Abbrechen',
        // Matching
        matchingTitle: 'Abgleichergebnisse',
        bankTransaction: 'Bankvorgang',
        expenseMatch: 'Ausgabenabgleich',
        revenueMatch: 'Einnahmenabgleich',
        matched: 'Abgeglichen',
        unmatched: 'Nicht abgeglichen',
        partialMatch: 'Teilweise',
        noMatch: 'Kein Treffer',
        // Summary
        matchSummary: 'Abgleich-Zusammenfassung',
        totalTransactions: 'Transaktionen gesamt',
        matchedCount: 'Abgeglichen',
        unmatchedCount: 'Nicht abgeglichen',
        //Headers
        groupHeaderBank: 'Kontoauszug',
        groupHeaderDocs: 'Ausgaben & Einnahmen',
        swapPrimaryView: 'Tabellen tauschen',
        // Columns
        colDate: 'Datum',
        colDescription: 'Beschreibung',
        colAmount: 'Betrag',
        colFilename: 'Dateiname',
        colMatch: 'Abgleich',
        colConfidence: 'Konfidenz',
        colType: 'Typ',
        debit: 'Ausgang',
        credit: 'Eingang',
        colDocument: 'Dokument',
        // Confidence
        highConfidenceCount: 'Hohe Konfidenz',
        confidenceHigh: 'Hoch',
        confidenceMedium: 'Mittel',
        confidenceLow: 'Niedrig',
        // Matching actions
        matchButton: 'Alle abgleichen',
        rematchButton: 'Alle abgleichen',
        autoMatchStepLabel: 'Mit einem Klick alles abgleichen',
        autoMatchTooltip: 'Banktransaktionen werden automatisch mit Rechnungen abgeglichen. Manuell verknüpfte Dokumente bleiben erhalten.',        matchingInProgress: 'Abgleich läuft...',
        matchingComplete: 'Abgleich abgeschlossen',
        lastMatchInfo: '{count} neue Übereinstimmungen gefunden',
        reconNotifExpenses: 'Ausgaben',
        reconNotifRevenues: 'Einnahmen',
        reconNotifStatements: 'Kontoauszüge',
        reconNotifUnprocessed: 'wurden noch nicht automatisch abgeglichen',
        reconNotifAllProcessed: 'Alle Dokumente wurden verarbeitet',
        matchingFailed: 'Abgleich fehlgeschlagen',
        noMatchesYet: 'Noch keine Abgleiche',
        noMatchesHint: 'Laden Sie Dokumente und Kontoauszüge hoch und klicken Sie auf "Abgleichen"',
        deleteMatchConfirm: 'Möchten Sie diesen Abgleich wirklich löschen?',
        // Empty state
        noTransactionsToMatch: 'Keine Transaktionen zum Abgleich',
        noTransactionsHint: 'Beginnen Sie mit dem Hochladen eines Kontoauszugs',
        // Filters
        filterAll: 'Alle',
        filterMatched: 'Abgeglichen',
        filterUnmatched: 'Nicht abgeglichen',
        filterNew: 'Neu',
        filterNewTooltip: 'Nur Treffer aus dem letzten Abgleichlauf anzeigen',
        // Actions
        linkButton: 'Verknüpfen',
        unlinkButton: 'Trennen',
        confirmMatch: 'Bestätigen',
        unlinkConfirm: 'Möchten Sie diese Verknüpfung wirklich aufheben?',
        // Modal
        linkTransaction: 'Dokument verknüpfen',
        searchDocuments: 'Dateiname oder Lieferant suchen...',
        selectDocument: 'Auswählen',
        noDocumentsAvailable: 'Keine Dokumente verfügbar',
        // Status
        statusAuto: 'Automatisch',
        statusManual: 'Manuell',
        statusConfirmed: 'Bestätigt',
        // Pagination
        prevPage: 'Zurück',
        nextPage: 'Weiter',
        // Match Detail Modal
        matchDetailTitle: 'Abgleich-Detail',
        transactionInfo: 'Transaktionsdaten',
        linkedDocument: 'Verknüpftes Dokument',
        bankName: 'Bank',
        invoiceNumber: 'Rechnungsnr.',
        vendorName: 'Lieferant',
        previewDocument: 'Wählen Sie ein Dokument zur Vorschau',
        availableDocsTitle: 'Ausgaben & Einnahmen',
        closeButton: 'Schließen',
        // Multi-link
        linkedDocuments: 'Verknüpfte Dokumente',
        bankStatementPreview: 'Kontoauszug',
        highlightTransaction: 'Transaktion hervorheben',
        fileNotFound: 'Datei nicht verfügbar',
        documentAlreadyLinked: 'Dokument bereits verknüpft',
        linkMore: 'Weitere verknüpfen',
        // Document Picker
        confirmLinkTitle: 'Dieses Dokument verknüpfen?',
        confirmLinkYes: 'Ja, verknüpfen',
        confirmLinkCancel: 'Abbrechen',
        docAdded: 'Hinzugefügt',
        proximityScore: 'Bewertung',
        pickerExpenses: 'Ausgaben',
        pickerRevenue: 'Einnahmen',
        showAllDocs: 'Alle Dokumente anzeigen',
        dateRange: 'Zeitraum',
        days: 'Tage',
        pickerDate: 'Datum',
        pickerAmount: 'Betrag',
        pickerCurrency: 'Währung',
        pickerSupplier: 'Lieferant',
        more: 'Mehr',
        loadingDocs: 'Laden...',
        // Re-match options
        rematchOptionTitle: 'Neu abgleichen',
        rematchOptionMessage: 'Was soll mit den vorhandenen Verknüpfungen passieren?',
        rematchPreserve: 'Nur neu hinzugefügte Dateien verknüpfen (Empfohlen)',
        rematchPreserveHint: 'Nur neu hinzugefügte Dokumente werden verknüpft',
        rematchKeepManual: 'Manuelle Verknüpfungen behalten',
        rematchKeepManualHint: 'Auto-Abgleiche werden entfernt, manuelle bleiben erhalten',
        rematchSelectiveBtn: 'Selektiv verknüpfen',
        rematchSelectiveHint: 'Wählen Sie, welche Verknüpfungen behalten werden',
        // Selective re-match modal
        rematchModalTitle: 'Selektiv erneut abgleichen',
        rematchModalDesc: 'Wählen Sie die Zuordnungen, die beibehalten werden sollen. Nicht ausgewählte werden gelöscht und neu abgeglichen.',
        rematchSelectAll: 'Alle auswählen',
        rematchDeselectAll: 'Alle abwählen',
        rematchRunButton: 'Erneut abgleichen',
        rematchRunCount: 'Zuordnung(en) werden beibehalten',
        rematchNoMatches: 'Noch keine Zuordnungen',
        searchTransactions: 'Transaktion, Beschreibung oder Dokument suchen...',
        showMore: 'Mehr anzeigen',
        showLess: 'Weniger anzeigen',
        exportExcel: 'Exportieren',
        showPerPage: 'Anzeigen',
        // Month filter
        monthAll: 'Alle',
        monthJan: 'Jan', monthFeb: 'Feb', monthMar: 'Mär', monthApr: 'Apr',
        monthMay: 'Mai', monthJun: 'Jun', monthJul: 'Jul', monthAug: 'Aug',
        monthSep: 'Sep', monthOct: 'Okt', monthNov: 'Nov', monthDec: 'Dez',
        // Stale warnings
        staleWarning: 'Dokument wurde bearbeitet. Zuordnung evtl. veraltet',
        staleFieldsEdited: 'Bearbeitete Felder:',
        staleDismiss: 'OK',
        staleDismissConfirm: 'Möchten Sie diese Warnung wirklich schließen? Die Zuordnung wird als aktuell markiert.',
        aiReviewButton: 'KI-Analyse',
        aiLoading: 'Analyse läuft...',
        aiRetry: 'Erneut analysieren',
        // Month picker
        monthsSelected: 'Monate ausgewählt',
        dateFrom: 'Von',
        dateTo: 'Bis',
        filterApply: 'Anwenden',
        // Duplicate exclusion
        duplicateExcludedCount: '{count} doppelte Transaktionen ausgeschlossen',
        duplicateExcludedTooltip: 'Als Duplikat markierte oder manuell ausgeschlossene Transaktionen werden nicht in den Abgleich einbezogen',
        // Export
        exportDate: 'Datum',
        exportDescription: 'Beschreibung',
        exportAmount: 'Betrag',
        exportType: 'Typ',
        exportMatchedDoc: 'Zugeordnetes Dokument',
        exportVendor: 'Lieferant',
        exportDocAmount: 'Dokumentbetrag',
        exportDocDate: 'Dokumentdatum',
        exportConfidence: 'Konfidenz',
        exportStatus: 'Status',
        exportMatched: 'Abgeglichen',
        exportUnmatched: 'Nicht abgeglichen',
        exportPeriod: 'Zeitraum',
        exportTxCount: 'Transaktionsanzahl',
        exportMatchedCount: 'Abgeglichen',
        exportUnmatchedCount: 'Nicht abgeglichen',
        exportTotalAmount: 'Gesamtbetrag',
        exportSummarySheet: 'Zusammenfassung',
        exportNoData: 'Keine Transaktionen im ausgewaehlten Zeitraum gefunden.',
        exportFilenamePrefix: 'Abgleich_',
        exportMonthJan: 'Januar', exportMonthFeb: 'Februar', exportMonthMar: 'Maerz',
        exportMonthApr: 'April', exportMonthMay: 'Mai', exportMonthJun: 'Juni',
        exportMonthJul: 'Juli', exportMonthAug: 'August', exportMonthSep: 'September',
        exportMonthOct: 'Oktober', exportMonthNov: 'November', exportMonthDec: 'Dezember',
    },
};
